<div class="container">
  <div class="card-container" *ngFor="let item of cardList">
    <img *ngIf="item.url" class="card" [src]="item.url">
    <p class="card-text">{{ item.description }}</p>
  </div>
</div>
